<template>
  <div class="share" v-bind:class="{ 'share--hidden': hidden }">
    <button class="share__close-icon" v-on:click="toggleShareDialog()">'</button>
    <form name="share-link-form" class="share__link">
      <label for="link-text" class="share__link-label">Click on the icon or use CTRL+C<br/>to copy the link:</label>
      <input id="share-link" name="share-link" type="text" class="share__link-input" :value="fullLink" />
      <button type="button" class="share__link-button" title="copy to clipboard" v-on:click="copyToClipboard('share-link')">D</button>
    </form>
    <div class="share__email">
      Or <a :href="mailToLink" data-gtm-category="Share" data-gtm-action="Email" :data-gtm-label="link">send using your email client</a>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  
  export default Vue.component('ShareDialog', {
    props: {
      hidden: Boolean,
      link: String,
      toggleShareDialog: Function,
    },
    computed: {
      fullLink: function() {
        return `${window.location.protocol}//${window.location.hostname}${this.link}`;
      },
      mailToLink: function() {
        return `mailto:?subject=Link%20to%20the%20Business%20Industry%20Codes&body=The%20following%20is%20a%20link%20to%20the%20codes%20selected%20on%20the%20Business%20Industry%20Classification%20codes%20website:%20${encodeURIComponent(this.fullLink)}`;
      },
    },
    methods: {
      selectMode: function(mode) {
        this.mode = mode;
      },
      copyToClipboard: function(elId) {
        const copyText = document.getElementById(elId);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/
        /* Copy the text inside the text field */
        document.execCommand("copy");
      },
    }
  });
</script>